import { createBlocksModel } from '@wix/yoshi-flow-editor/blocks';

export default createBlocksModel({
  widgetName: 'Above content 1',
  props: {},
  methods: {},
  events: {},
});
